export const BUSINESS_DOCS_LABELS = {
  TITLE: "Business Docs",
  DESCRIPTION: "Create all your business policies/documents and map up to %s documents to each Biz.",
  CREATE_DOC: "Create Doc",
  ADD_RICH_TEXT: "Write Doc",
  ADD_PDF: "Upload PDF",
  DOC_NAME: "Document Name",
  DOC_NAME_REQUIRED: "Enter a document name.",
  DOC_TYPE: "Type",
  UPDATED_ON: "Updated",
  UPDATED_BY: "Updated By",
  SAVE: "Save",
  CANCEL: "Cancel",
  DELETE: "Delete",
  EDIT: "Edit",
  NO_DOCS: "No Business Docs created yet.",
  DELETE_BLOCKED: "This document is attached to a Biz. Delink it before deleting.",
  SAVE_SUCCESS: "BusinessDoc saved.",
  DELETE_SUCCESS: "BusinessDoc deleted.",
  LOAD_ERROR: "Failed to load BusinessDocs.",
  SAVE_ERROR: "Failed to save BusinessDoc.",
  DELETE_ERROR: "Failed to delete BusinessDoc.",
  PDF_ONLY: "Only PDF files are allowed.",
  BIZ_MAPPING_TITLE: "Business Docs",
  BIZ_MAPPING_HELP: "Map up to %s hub documents to this Biz.",
  BIZ_MAPPING_LABEL: "Display Label",
  BIZ_MAPPING_DOC: "Hub Document",
  BIZ_MAPPING_LABEL_REQUIRED: "Enter display label.",
  BIZ_MAPPING_DOC_REQUIRED: "Select document.",
  ADD_MAPPING: "Add Doc Mapping",
  VIEW_DOC: "View",
  DELINK_DOC: "Delink",
};
